import { Services } from '@sigma-frontend-libs/commons'
import { RECURRENT_PAYMENTS_STATUSES, RECURRENT_PAYMENTS_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'RecurrentPaymentsFilter',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isPage: Boolean,
    OwnerId: String
  },

  computed: {
    canGetUsers() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    },
    canCreateRecurrentPayments() {
      return this.checkPermissions(`advanced.${Services.recurrentPayments}.create`, permissionPresets.meUp)
    },

    types() {
      return RECURRENT_PAYMENTS_TYPES.map(type => {
        return {
          title: this.getTranslate(`${Services.recurrentPayments}.types.${type}`),
          value: type
        }
      })
    },

    statuses() {
      return RECURRENT_PAYMENTS_STATUSES.map(status => {
        return {
          title: this.getTranslate(`${Services.recurrentPayments}.statuses.${status}`),
          value: status
        }
      })
    }
  },

  render
}
